module.exports = __webpack_public_path__ + "static/media/Jubel-Bold.8fc5f307.woff2";